export default "__VITE_ASSET__QcMtUypb__"